import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
      <h1 className="text-6xl font-bold text-green-800 mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Page non trouvée</p>
      <Link 
        to="/"
        className="px-6 py-3 bg-green-700 text-white rounded-md hover:bg-green-800 transition"
      >
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default NotFound;
